import { useSelector } from "react-redux";

const useLogoUrl = () => {
  const { setupDetails } = useSelector((state) => state.SetupReducer);
  if (!setupDetails?.logoPath || !setupDetails?.logo) return null;
  return setupDetails.logoPath + setupDetails.logo;
};

export default useLogoUrl;
